module.exports = __webpack_public_path__ + "img/DrySystem-User.70ed5d1b.jpg";